import { fromPromise } from 'xstate5';

import {
  type FetchReceiptInput,
  type FetchReceiptResponse,
  type ClaimReceiptInput,
  type ClaimReceiptResponse,
} from '../receipt.machine.types';

// ─── External Actors ─────────────────────────────────────────────────────────

const fetchReceipt = fromPromise<FetchReceiptResponse, FetchReceiptInput>(async () => {
  throw new Error('Not implemented');
});

const claimReceipt = fromPromise<ClaimReceiptResponse, ClaimReceiptInput>(async () => {
  throw new Error('Not implemented');
});

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  fetchReceipt,
  claimReceipt,
};
